"use client";
import Script from "next/script";

export default function GaHomepage() {
    return (
        <>
            <Script
                src="https://www.googletagmanager.com/gtag/js?id=G-1S0SBFPXQ9"
                strategy="afterInteractive"
            />
            <Script id="ga4-gtag" strategy="afterInteractive">
                {`
                      window.dataLayer = window.dataLayer || [];
                      function gtag(){dataLayer.push(arguments);}
                      gtag('js', new Date());
                      gtag('config', 'G-1S0SBFPXQ9');
                `}
            </Script>
        </>
    );
}
